(function ($) {
  const $context = $('.price-list-container');

  const $crop = $('.crop', $context);
  const $oil = $('.oil', $context);

  const $cropData = $('.crop-data', $context);
  const $oilData = $('.oil-data', $context);

  $crop.on('click', function () {
    $oil.removeClass('active');
    $crop.addClass('active');

    $oilData.removeClass('active');
    $cropData.addClass('active');
  });

  $oil.on('click', function () {
    $crop.removeClass('active');
    $oil.addClass('active');

    $cropData.removeClass('active');
    $oilData.addClass('active');
  });

  let grainsList = $('.dropdown-item');

  grainsList.each(function () {
    this.addEventListener('click', function (e) {
      e.preventDefault();

      for (let i = 1; i <=4 ; i++) {
        $('#grain-'+i, $context).addClass('disabled');
      }
      $('#grain-'+this.dataset.grain, $context).removeClass('disabled');

      let selectedGrain = this.innerHTML;
      $('#dropdown-day-grain-price').find('span')[0].innerHTML = selectedGrain;
    });
  });
})(jQuery);